/* トップページ左右のサイドバナー（PCのみ）
 *
 * 表示・非表示の制御はしない。バナーはセクションを置いた位置から下に
 * 絶対配置され、中身が position: sticky で追随する。CSSだけで完結する。
 *
 * JS の役割は「追随できる縦の長さ」を測ることだけ。
 * 親の高さは 0 なので、sticky が効く範囲を明示的に与えないと追随しない。
 * 起点からフッターの手前までを高さにすることで、フッターに重ならず止まる。
 *
 * 追随して止まる位置は「画面の縦中央」。バナーの高さは枚数で変わるので
 * CSS だけでは中央に置けず、実寸を測って top を出す。
 * ページ上の座標ではなく画面の高さから計算する点が重要で、
 * 座標から出すと画面のずっと下に貼り付いてしまう。
 */
(function () {
  'use strict';
  /* 同じスクリプトを複数セクションが読み込む可能性があるため、
     タグごとの重複実行を防ぐ */
  if (window.mdlSideBannersReady) return;
  window.mdlSideBannersReady = true;

  function pageY(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  function layout(anchor) {
    var panels = anchor.querySelectorAll('.mdl-side-banners');
    if (!panels.length) return;

    var bottomGap = parseInt(anchor.getAttribute('data-bottom-gap'), 10);
    if (isNaN(bottomGap)) bottomGap = 40;

    var selector = anchor.getAttribute('data-stop') || '';
    var stopEl = null;
    if (selector) {
      // 設定値をそのまま querySelector に渡すため、不正な指定で落ちないようにする
      try {
        stopEl = document.querySelector(selector);
      } catch (e) {
        stopEl = null;
      }
    }

    var stopY;
    if (stopEl) {
      stopY = pageY(stopEl);
    } else {
      var main = document.getElementById('MainContent');
      stopY = main ? pageY(main) + main.offsetHeight : document.documentElement.scrollHeight;
    }

    var height = Math.max(0, stopY - pageY(anchor) - bottomGap);

    // 画面の上下に最低限あけておく余白
    var minGap = parseInt(anchor.getAttribute('data-min-gap'), 10);
    if (isNaN(minGap)) minGap = 24;

    for (var i = 0; i < panels.length; i++) {
      panels[i].style.height = height + 'px';

      var inner = panels[i].querySelector('.mdl-side-banners__inner');
      if (!inner) continue;

      /* 実寸を測るために一旦解除する。前回の max-height が残っていると
         そこで頭打ちになった高さしか取れない */
      inner.style.top = '';
      inner.style.maxHeight = '';

      var top = Math.round((window.innerHeight - inner.offsetHeight) / 2);
      if (top < minGap) top = minGap;

      inner.style.top = top + 'px';
      inner.style.maxHeight = 'calc(100vh - ' + (minGap * 2) + 'px)';
    }
  }

  function layoutAll() {
    var anchors = document.querySelectorAll('[data-mdl-side-banners-anchor]');
    for (var i = 0; i < anchors.length; i++) layout(anchors[i]);
  }

  function boot() {
    layoutAll();

    // 画像の読み込みや後から差し込まれる要素でページの高さが変わるため、
    // 一度測って終わりにはしない
    window.addEventListener('resize', layoutAll, { passive: true });
    window.addEventListener('load', layoutAll);

    if (typeof ResizeObserver === 'function') {
      var target = document.getElementById('MainContent') || document.body;
      new ResizeObserver(layoutAll).observe(target);
    }

    /* テーマエディタでセクションを追加・削除・並び替えすると起点の位置が変わる。
       並び替えはページ全体の高さを変えないことがあり、その場合 ResizeObserver は
       発火しないため、Shopify のイベントからも measure し直す。
       layoutAll は毎回 DOM を引き直すので、後から増えた起点も拾える。 */
    /* 画像が読み込まれると高さが変わる。lazy 読み込みなので
       load イベントより後に確定することがある */
    var images = document.querySelectorAll('.mdl-side-banners__item img');
    for (var n = 0; n < images.length; n++) {
      if (images[n].complete) continue;
      images[n].addEventListener('load', layoutAll);
    }

    ['shopify:section:load',
     'shopify:section:unload',
     'shopify:section:reorder',
     'shopify:section:select',
     'shopify:section:deselect'].forEach(function (name) {
      document.addEventListener(name, layoutAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
